import { removeLabelCharacter } from "./getName";

/**
 * @typedef {Object} FieldObject
 * @property {string} field_type
 * @property {string} is_required
 * @property {string} field_label
 * @property {Array<FieldObject>} field_items
 */

/**
 *
 * @param {Array<FieldObject>} formFields
 */
const getInitialValues = (formFields) => {
  let initialValues = {};

  if(typeof formFields === 'string'){
    formFields = JSON.parse(formFields)
  }

  formFields.forEach((field, index) => {
    if (field.field_type !== "sect-title" && field.field_type !== "divider") {
      if (field.field_label && field.field_items) {
        if (
          field.field_type !== "radio" &&
          field.field_type !== "checkbox" &&
          field.field_type !== "dropdown"
        ) {
          initialValues = {
            ...initialValues,
            [field.field_type]: {
              name: field.field_label,
              type: field.field_type,
              fields: {},
            },
          };
        }
       
        field.field_items.forEach((item) => {  
          if (typeof item !== "string" ) {
            if(item.field_label !== undefined  && initialValues[field.field_type] !== undefined)
            {initialValues[field.field_type]["fields"][item.field_label] = "";}
          } else {
            if (field.field_type === "checkbox") {
              initialValues[field.field_label] = [];
            } else {
              initialValues[field.field_label] = "";
            }
          }
        });
      } else {
        initialValues = { ...initialValues, [field.field_label]: "" };
      }
    }
  });
  return initialValues;
};


/**
 *
 * @param {Array<FieldObject>} formFields
 */
export const getInitialValues2 = (formFields) => {
  let initialValues = {};

  if (typeof formFields === 'string') {
    formFields = JSON.parse(formFields);
  }

  const nameCount = {}; // To keep track of field label counts

  // Helper function to generate a unique key
  const generateKey = (label, count) => {
    let baseKey = label.toLowerCase().replace(/\s/g, '_');
    let suffix = count[baseKey] ? `_${count[baseKey]}` : '';
    return `${baseKey}${suffix}`;
  };

  formFields.forEach((field, keyIndex) => {
    if (field.field_type !== "sect-title" && field.field_type !== "divider") {
      let baseKey = (field.field_label || `field_${keyIndex}`).toLowerCase().replace(/\s/g, '_');
      nameCount[baseKey] = (nameCount[baseKey] || 0) + 1;
      let keySuffix = nameCount[baseKey] > 1 ? `_${nameCount[baseKey] - 1}` : '';
      let key = `${baseKey}${keySuffix}`;

      if (field.field_label && field.field_items) {
        if (!["radio", "checkbox", "dropdown"].includes(field.field_type)) {
          initialValues[key] = {
            name: `${field.field_label}${keySuffix}`,
            // type: `${field.field_type.toLowerCase()}${keySuffix}`,
            type: `${field.field_type.toLowerCase()}`,
            fields: {},
          };

          const itemNameCount = {}; // To keep track of field item label counts within each field

          field.field_items.forEach((item, index) => {
            if (typeof item !== "string") {
              let itemBaseKey = (item.field_label || `field_item_${index}`).toLowerCase().replace(/\s/g, '_');
              itemNameCount[itemBaseKey] = (itemNameCount[itemBaseKey] || 0) + 1;
              let itemKeySuffix = keySuffix ? `_${nameCount[baseKey] - 1}` : '';
              let itemKey = `${itemBaseKey}${itemKeySuffix}`;

              initialValues[key].fields[itemKey] = "";
            }
          });
        } else {
          initialValues[key] = "";
        }
      } else {
        initialValues[key] = "";
      }
    }
  });

  return initialValues;
};
/**
 *
 * @param {Array<FieldObject>} formFields
 */
export const getInitialValues3 = (formFields) => {
  let initialValues = {};

  if (typeof formFields === 'string') {
    formFields = JSON.parse(formFields);
  }

  const nameCount = {}; // To keep track of field label counts
  const typeCount = {}

  // Helper function to generate a unique key
  const generateKey = (label, count) => {
    let baseKey = label.toLowerCase().replace(/\s/g, '_');
    let suffix = count[baseKey] ? `_${count[baseKey]}` : '';
    return `${baseKey}${suffix}`;
  };

  formFields.forEach((field, keyIndex) => {
    let labelWithoutChar = removeLabelCharacter(field.field_label)
    if (field.field_type !== "sect-title" && field.field_type !== "divider") {
      let baseKey = (labelWithoutChar || `field_${keyIndex}`).toLowerCase().replace(/\s/g, '_');
      let typeBaseKey = (field.field_type || `field_${keyIndex}`).toLowerCase().replace(/\s/g, '_');
      nameCount[baseKey] = (nameCount[baseKey] || 0) + 1;
      typeCount[typeBaseKey] = (typeCount[typeBaseKey] || 0) + 1;
      let keySuffix = nameCount[baseKey] > 1 ? `_${nameCount[baseKey] - 1}` : '';
      let key = `${baseKey}${keySuffix}`;
      let typeKeySuffix = typeCount[typeBaseKey] > 1 ? `_${typeCount[typeBaseKey] - 1}` : '';
      let typeKey = `${typeBaseKey}${typeKeySuffix}`;

      if (labelWithoutChar && field.field_items) {
       
        // if (!["radio", "checkbox", "dropdown"].includes(field.field_type)) {
        if (!field.field_type.includes('radio') && !field.field_type.includes('checkbox') && !field.field_type.includes('dropdown')) {
          initialValues[typeKey] = {
            label: `${labelWithoutChar}${keySuffix}`,
            // name: `${labelWithoutChar}${keySuffix}`,
            // type: `${field.field_type.toLowerCase()}${keySuffix}`,
            name: `${field.field_type.toLowerCase()}${typeKeySuffix}`,
            type: `${field.field_type.toLowerCase()}${typeKeySuffix}`,
            fields: {},
          };

        }
        const itemNameCount = {}; // To keep track of field item label counts within each field

        field.field_items.forEach((item, index) => {
          if (typeof item !== "string") {
            let itemBaseKey = (item.field_label || `field_item_${index}`).toLowerCase().replace(/\s/g, '_');
            itemNameCount[itemBaseKey] = (itemNameCount[itemBaseKey] || 0) + 1;
            let itemKeySuffix = keySuffix ? `_${nameCount[baseKey] - 1}` : '';
            let itemKey = `${itemBaseKey}${itemKeySuffix}`;
            
            if (initialValues[typeKey]?.fields) {
              initialValues[typeKey].fields[itemKey] = "";
            }
          }else{
            if (field.field_type?.includes("checkbox")) {
              initialValues[labelWithoutChar] = [];
            } else {
              initialValues[labelWithoutChar] = "";
            }
          }
        });
        if (field.field_type.includes('dropdown')) {
          
          initialValues[field['field_label']] = ""
        }
        
      } else {
        initialValues = { ...initialValues, [labelWithoutChar]: "" };
      }
    }
  });

  return initialValues;
};

export default getInitialValues;
